import { Flex } from "@chakra-ui/react"
import { HomeLogoCarouselProps } from "@definitions/types"
import Autoplay from "embla-carousel-autoplay"
import useEmblaCarousel from "embla-carousel-react"
import Image from "next/image"
import { useRouter } from "next/router"

const HomeLogoCarousel = ({ logos }: HomeLogoCarouselProps) => {
  const { locale } = useRouter()

  const [emblaRef] = useEmblaCarousel(
    {
      containScroll: "trimSnaps",
      loop: true,
      direction: locale === "ar" ? "rtl" : "ltr",
    },
    [Autoplay({ stopOnInteraction: false, delay: 2000 })]
  )

  return (
    <Flex
      overflow={"hidden"}
      dir={locale === "ar" ? "rtl" : "ltr"}
      ref={emblaRef}
    >
      <Flex>
        {logos.map((logo, index) => (
          <Flex
            key={index}
            m={{ base: 2, md: 4 }}
            borderRadius={"lg"}
            overflow={"hidden"}
            flexShrink={0}
            flexGrow={0}
            minW={{ base: 6, md: 10 }}
            minH={{ base: 6, md: 10 }}
            flexBasis={{ base: "30%", md: "12%" }}
            shadow={"sm"}
          >
            <Image
              src={logo.image}
              loader={({ src }) => src}
              alt={logo.name}
              style={{
                objectFit: "contain",
                objectPosition: "center",
              }}
              quality={100}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}

export default HomeLogoCarousel
